window.handleize = function (input) {
    return (
        input
            // 1. Decompose accented letters into letter + diacritic mark
            .normalize("NFD")
            // 2. Toss out the diacritic marks
            .replace(/[\u0300-\u036f]/g, "")
            // 3. Lower-case everything
            .toLowerCase()
            // 4. Trim leading/trailing space
            .trim()
            // 5. Remove everything except letters, numbers, spaces, and dashes
            .replace(/[^a-z0-9\s-]/g, "")
            // 6. Replace groups of whitespace with a single dash
            .replace(/\s+/g, "-")
            // 7. Collapse multiple dashes (in case input had "--" etc.)
            .replace(/-+/g, "-")
    );
};
